import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Page from './components/Page';
import Home from './pages/Home';
import NoMatch from './pages/404';

const lazyPage = (load) => React.lazy(async () => {
  const module = await load();
  return { default: module.default };
});

const Administration = lazyPage(() => import('./pages/Administration'));
const Automation = lazyPage(() => import('./pages/Automation'));
const Hosting = lazyPage(() => import('./pages/Hosting'));
const Software = lazyPage(() => import('./pages/Software'));
const Imprint = lazyPage(() => import('./pages/Imprint'));
const PrivacyPolicy = lazyPage(() => import('./pages/PrivacyPolicy'));
const A11y = lazyPage(() => import('./pages/A11y'));
const Exp = lazyPage(() => import('./pages/Exp'));

const routeDefinitions = [
  { path: '/administration', index: true, Component: Administration },
  { path: '/software', index: true, Component: Software },
  { path: '/hosting', index: true, Component: Hosting },
  { path: '/impressum', index: true, Component: Imprint },
  { path: '/datenschutz', index: true, Component: PrivacyPolicy },
  { path: '/barrierefreiheit', index: true, Component: A11y },
  { path: '/automation', index: false, Component: Automation },
  { path: '/exp', index: false, Component: Exp },
];

export const prerenderRoutes = [
  { path: '/', index: true },
  ...routeDefinitions.map(({ path, index }) => ({ path, index })),
];

const AppRouteElements = () => (
  <React.Suspense fallback={null}>
    <Routes>
      <Route element={<Page />}>
        <Route path="/" element={<Home />} />
        {routeDefinitions.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  </React.Suspense>
);

export default AppRouteElements;
